// import React, { useEffect, useState } from "react";
// import {
//   MapPin,
//   Download,
//   CalendarDays,
//   UserRound,
//   Phone,
//   ClipboardList,
//   Store,
//   Mail,
//   BadgeInfo,
//   UsersRound,
//   IndianRupee,
//   Eye,
//   ExternalLink,
//   X,
//   ChevronRight,
//   Briefcase,
//   Tag,
//   Layers,
//   Play,
//   AlertTriangle,
// } from "lucide-react";
// import { useParams } from "react-router-dom";

// import {
//   getJobDetailTestData,
//   getInspectionPhotoUrl,
//   getInspectionMediaUrl,
//   isInspectionVideo,
//   generateJobReport,
//   TEST_JOB_ID,
// } from "../services/jobDetailTestService";

// import { fetchJobMedia } from "../services/jobListService";
// import { getJobMediaDiscrepancies } from "../services/mediaDiscrepancyService";
// import "./job_detail_test.css";

// const Field = ({ label, value, children }) => (
//   <div className="field">
//     <div className="field-label">{label}</div>
//     <div className="field-value">{children ?? value}</div>
//   </div>
// );

// // Helper function to enrich media object structure
// const enrichDetailMedia = (media, index, job) => {
//   if (!media) return {};

//   if (typeof media === "string") {
//     return {
//       url: media,
//       media_index: index,
//       source_type: "job_message",
//       source_id: job?.message_job_id ?? null,
//       job_id: job?.id ?? null,
//     };
//   }

//   return {
//     ...media,

//     job_id:
//       media?.job_id ??
//       media?.jobId ??
//       job?.id ??
//       job?.job_id ??
//       null,

//     media_index:
//       media?.media_index ??
//       media?.mediaIndex ??
//       index,

//     source_type:
//       media?.source_type ??
//       media?.sourceType ??
//       "job_message",

//     source_id:
//       media?.source_id ??
//       media?.sourceId ??
//       media?.message_id ??
//       media?.messageId ??
//       media?.id ??
//       job?.message_job_id ??
//       job?.messageJobId ??
//       null,
//   };
// };

// const getDetailMediaUrl = (media) => {
//   if (!media) return "";
//   return getInspectionMediaUrl(media) || (typeof media === "string" ? media : media.url || media.photo_url || "");
// };

// // Unique key generator for media mapping
// const getDetailMediaKey = (media, index, job) => {
//   const enriched = enrichDetailMedia(media, index, job);

//   const sourceType =
//     enriched.source_type || "job_message";

//   const sourceId =
//     enriched.source_id || "unknown";

//   const mediaIndex =
//     enriched.media_index ?? index;

//   const url =
//     getDetailMediaUrl(enriched);

//   return `${sourceType}-${sourceId}-${mediaIndex}-${url || ""}`;
// };

// function JobDetailTest() {
//   const { jobId: routeJobId } = useParams();

//   const [job, setJob] = useState(null);
//   const [inspectionPhotos, setInspectionPhotos] = useState([]);
//   const [inspectionVideos, setInspectionVideos] = useState([]);
//   const [permissions, setPermissions] = useState({
//     showOwner: false,
//     showSnapperApplications: false,
//     showTransactions: false,
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);
//   const [isGeneratingReport, setIsGeneratingReport] = useState(false);

//   // Discrepancies state map
//   const [mediaDiscrepancies, setMediaDiscrepancies] = useState({});

//   useEffect(() => {
//     let cancelled = false;

//     const loadJob = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const result = await getJobDetailTestData(routeJobId);

//         if (cancelled) return;

//         setJob(result?.job || {});
//         setInspectionPhotos(result?.photos || []);
//         setInspectionVideos(result?.videos || []);

//         console.log("[JOB DETAIL PAGE] Images:", result?.photos || []);
//         console.log("[JOB DETAIL PAGE] Videos:", result?.videos || []);

//         setPermissions(
//           result?.permissions || {
//             showOwner: false,
//             showSnapperApplications: false,
//             showTransactions: false,
//           }
//         );
//       } catch (err) {
//         console.error("[JOB DETAIL TEST] Failed to load:", err);

//         if (!cancelled) {
//           setError(err?.message || "Failed to load job details.");
//           setJob(null);
//           setInspectionPhotos([]);
//           setInspectionVideos([]);
//         }
//       } finally {
//         if (!cancelled) {
//           setLoading(false);
//         }
//       }
//     };

//     loadJob();

//     return () => {
//       cancelled = true;
//     };
//   }, [routeJobId]);

//   const openPhoto = (index) => {
//     setSelectedPhotoIndex(index);
//   };

//   const closePhoto = () => {
//     setSelectedPhotoIndex(null);
//   };

//   const allMedia = [...inspectionPhotos, ...inspectionVideos];

//   useEffect(() => {
//     if (!job || allMedia.length === 0) {
//       setMediaDiscrepancies({});
//       return;
//     }

//     let cancelled = false;

//     const loadJobDiscrepancies = async () => {
//       try {
//         // IMPORTANT:
//         // routeJobId is REQUEST ID for this Job Detail page.
//         // The backend now converts request_id -> actual job_id internally.
//         const requestId = Number(routeJobId);

//         console.log(
//           "[JOB DETAIL] REQUEST ID FOR DISCREPANCY API:",
//           requestId
//         );

//         if (!requestId) {
//           console.error(
//             "[JOB DETAIL] Missing request ID"
//           );
//           return;
//         }

//         // DO NOT convert this to actual job_id here.
//         const result =
//           await getJobMediaDiscrepancies(requestId);

//         console.log(
//           "[JOB DETAIL] RAW DISCREPANCY RESULT:",
//           result
//         );

//         if (cancelled) return;

//         const discrepancies =
//           Array.isArray(result)
//             ? result
//             : result?.discrepancies || [];

//         console.log(
//           "[JOB DETAIL] DISCREPANCIES:",
//           discrepancies
//         );

//         const results = {};

//         discrepancies.forEach((item) => {
//           const sourceType =
//             item?.source_type ??
//             item?.sourceType ??
//             "job_message";

//           const sourceId =
//             item?.source_id ??
//             item?.sourceId ??
//             null;

//           const mediaIndex =
//             item?.media_index ??
//             item?.mediaIndex ??
//             null;

//           /*
//            * IMPORTANT:
//            * Backend returns media_url as an array:
//            *
//            * media_url: ["https://..."]
//            *
//            * Convert it to the actual URL string.
//            */
//           const mediaUrl = Array.isArray(item?.media_url)
//             ? item.media_url[0]
//             : (
//                 item?.media_url ??
//                 item?.mediaUrl ??
//                 ""
//               );

//           const discrepancy =
//             item?.discrepancy === true ||
//             item?.discrepancy === 1 ||
//             item?.discrepancy === "1" ||
//             item?.discrepancy === "true" ||
//             item?.discrepancy === "TRUE";

//           const remark =
//             item?.discrepancy_reason ??
//             item?.discrepancyReason ??
//             item?.remark ??
//             "";

//           console.log(
//             "[JOB DETAIL] DISCREPANCY RECORD:",
//             {
//               sourceType,
//               sourceId,
//               mediaIndex,
//               mediaUrl,
//               rawDiscrepancy: item?.discrepancy,
//               discrepancy,
//               jobId: item?.job_id,
//             }
//           );

//           /*
//            * PRIMARY MATCH:
//            * Match the exact inspection-photo URL.
//            */
//           if (mediaUrl) {
//             results[`url-${mediaUrl}`] = {
//               discrepancy,
//               remark,
//               jobId: item?.job_id,
//               sourceType,
//               sourceId,
//               mediaIndex,
//               mediaUrl,
//             };
//           }

//           /*
//            * SECONDARY MATCH:
//            * Match source + source_id + media_index + URL.
//            */
//           if (
//             sourceId !== null &&
//             mediaIndex !== null
//           ) {
//             const mediaKey =
//               `${sourceType}-${sourceId}-${mediaIndex}-${mediaUrl}`;

//             results[mediaKey] = {
//               discrepancy,
//               remark,
//               jobId: item?.job_id,
//               sourceType,
//               sourceId,
//               mediaIndex,
//               mediaUrl,
//             };
//           }

//           /*
//            * EXTRA FALLBACK:
//            * Match by media index.
//            */
//           if (mediaIndex !== null) {
//             results[`index-${mediaIndex}`] = {
//               discrepancy,
//               remark,
//               jobId: item?.job_id,
//               sourceType,
//               sourceId,
//               mediaIndex,
//               mediaUrl,
//             };
//           }
//         });

//         console.log(
//           "[JOB DETAIL] FINAL DISCREPANCY MAP:",
//           results
//         );

//         setMediaDiscrepancies(results);

//       } catch (error) {
//         console.error(
//           "[JOB DETAIL] Discrepancy API error:",
//           error
//         );

//         if (!cancelled) {
//           setMediaDiscrepancies({});
//         }
//       }
//     };

//     loadJobDiscrepancies();

//     return () => {
//       cancelled = true;
//     };
//   }, [routeJobId, job, allMedia.length]);

//   const showPreviousPhoto = () => {
//     setSelectedPhotoIndex((current) => {
//       if (current === null || allMedia.length === 0) {
//         return current;
//       }

//       return (current - 1 + allMedia.length) % allMedia.length;
//     });
//   };

//   const showNextPhoto = () => {
//     setSelectedPhotoIndex((current) => {
//       if (current === null || allMedia.length === 0) {
//         return current;
//       }

//       return (current + 1) % allMedia.length;
//     });
//   };

//   const downloadReport = async () => {
//     if (!job?.id) {
//       alert("Job ID is missing.");
//       return;
//     }

//     try {
//       setIsGeneratingReport(true);
//       const result = await generateJobReport(job);

//       if (result?.download_url) {
//         const reportUrl = result.download_url.startsWith("http")
//           ? result.download_url
//           : `${process.env.REACT_APP_API_URL}${result.download_url}`;

//         window.open(reportUrl, "_blank", "noopener,noreferrer");
//       } else {
//         alert("Report generated, but download link was not returned.");
//       }
//     } catch (error) {
//       console.error("[JOB DETAIL] Report generation failed:", error);
//       alert(error?.message || "Failed to generate report.");
//     } finally {
//       setIsGeneratingReport(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="job-detail-page">
//         <main className="content">
//           <div className="card section-card">
//             <div className="field-value">Loading job details...</div>
//           </div>
//         </main>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="job-detail-page">
//         <main className="content">
//           <div className="card section-card">
//             <div className="field-value">{error}</div>
//           </div>
//         </main>
//       </div>
//     );
//   }

//   if (!job) {
//     return (
//       <div className="job-detail-page">
//         <main className="content">
//           <div className="card section-card">
//             <div className="field-value">No job data found.</div>
//           </div>
//         </main>
//       </div>
//     );
//   }

//   const formatDateTime = (value) => {
//     if (!value) return "N/A";

//     const date = new Date(value);

//     if (Number.isNaN(date.getTime())) {
//       return String(value);
//     }

//     return date.toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const appliedTime = formatDateTime(
//     job.applied_time ||
//       job.appliedTime ||
//       job.applied_at ||
//       job.appliedAt ||
//       job.created_at ||
//       job.createdAt
//   );

//   const completedAt = formatDateTime(
//     job.completed_at ||
//       job.completedAt ||
//       job.completed_at_time ||
//       job.linked_completed_at ||
//       job.linkedCompletedAt
//   );

//   const ownerPhone =
//     job.owner_phone ||
//     job.ownerPhone ||
//     job.owner?.phone ||
//     "N/A";

//   const ownerObject = job.owner && typeof job.owner === "object" ? job.owner : null;
//   const ownerName = job.owner_name || job.ownerName || ownerObject?.name || (typeof job.owner === "string" ? job.owner : "N/A");
//   const ownerEmail = job.owner_email || job.ownerEmail || ownerObject?.email || "N/A";
//   const ownerId = job.owner_id || job.ownerId || ownerObject?.id || "N/A";

//   const snapperObject = job.snapper && typeof job.snapper === "object" ? job.snapper : null;
//   const snapper = job.snapper_name || job.snapperName || snapperObject?.name || (typeof job.snapper === "string" ? job.snapper : "N/A");
//   const snapperPhone = job.snapper_phone || job.snapperPhone || snapperObject?.phone || "N/A";

//   const companyObject = job.company && typeof job.company === "object" ? job.company : null;
//   const company = job.company_name || companyObject?.name || (typeof job.company === "string" ? job.company : "N/A");

//   const brandObject = job.brand && typeof job.brand === "object" ? job.brand : null;
//   const brand = job.brand_name || brandObject?.name || (typeof job.brand === "string" ? job.brand : "N/A");

//   const campaignObject = job.campaign && typeof job.campaign === "object" ? job.campaign : null;
//   const campaign = job.campaign_name || campaignObject?.name || (typeof job.campaign === "string" ? job.campaign : "N/A");

//   const categoryObject = job.category && typeof job.category === "object" ? job.category : null;
//   const category = job.category_name || job.categoryName || categoryObject?.name || (typeof job.category === "string" ? job.category : "N/A");

//   const title = job.title || job.job_title || job.name || "N/A";
//   const displayJobId = job.snap_job_id || job.snapJobId || job.job_id || job.jobId || job.id || routeJobId || TEST_JOB_ID;
//   const status = job.status || job.job_status || "N/A";
//   const description = job.job_description || job.description || job.jobDescription || "N/A";

//   const locationData = job.location_data || job.locationData || job.location || {};
//   const latitude = job.latitude ?? job.lat ?? locationData.latitude ?? locationData.lat;
//   const longitude = job.longitude ?? job.lng ?? job.lon ?? locationData.longitude ?? locationData.lng;

//   const type = job.type || job.job_type || "N/A";
//   const price = job.price ?? job.budget ?? job.job_price ?? "N/A";
//   const acceptance = job.acceptance_type || job.acceptanceType || "N/A";
//   const hours = job.hours ?? job.duration ?? "N/A";

//   const allowGallery = job.allow_gallery ?? job.allowGallery;
//   const gallery = allowGallery === true ? "ENABLED" : allowGallery === false ? "DISABLED" : "N/A";

//   const zoho = job.zoho_item_id || job.zohoItemId || "N/A";
//   const gateway = job.payment_gateway || job.paymentGateway || "N/A";
//   const currency = job.currency || job.base_currency || "INR";

//   const addressNote = job.address_note || job.addressNote || job.location_note || "N/A";

//   const budget = job.budget_note || job.budgetNote || "N/A";
//   const reference = job.reference_description || job.referenceDescription || job.reference || "N/A";

//   const remark1 = job.remark1 || "N/A";
//   const remark2 = job.remark2 || "N/A";
//   const remark3 = job.remark3 || "N/A";
//   const remark4 = job.remark4 || "N/A";

//   const photosCount = allMedia.length || job.number_of_photos || job.numberOfPhotos || job.photos || 0;
//   const applications = job.snapper_applications || job.snapperApplications || job.applications || [];
//   const transactions = job.transactions || job.transaction_history || [];

//   const openInMaps = () => {
//     if (latitude === undefined || latitude === null || longitude === undefined || longitude === null) return;
//     window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank", "noopener,noreferrer");
//   };

//   // Show ALL inspection photos/videos
//   const previewPhotos = allMedia;

//   const selectedMedia =
//     selectedPhotoIndex !== null
//       ? allMedia[selectedPhotoIndex]
//       : null;

//   const selectedMediaUrl = selectedMedia ? getInspectionMediaUrl(selectedMedia) : null;
//   const selectedIsVideo = selectedMedia ? isInspectionVideo(selectedMedia) : false;

//   const selectedEnrichedMedia =
//     selectedMedia && selectedPhotoIndex !== null
//       ? enrichDetailMedia(selectedMedia, selectedPhotoIndex, job)
//       : null;

//   const selectedMediaKey =
//     selectedEnrichedMedia && selectedPhotoIndex !== null
//       ? getDetailMediaKey(
//           selectedEnrichedMedia,
//           selectedPhotoIndex,
//           job
//         )
//       : null;

//   const selectedUrlDiscrepancy =
//     selectedMediaUrl
//       ? mediaDiscrepancies[`url-${selectedMediaUrl}`]
//       : null;

//   const selectedKeyDiscrepancy =
//     selectedMediaKey
//       ? mediaDiscrepancies[selectedMediaKey]
//       : null;

//   const selectedDiscrepancyData =
//     selectedUrlDiscrepancy ||
//     selectedKeyDiscrepancy;

//   const selectedHasDiscrepancy =
//     selectedDiscrepancyData?.discrepancy === true;

//   const selectedRemark =
//     selectedDiscrepancyData?.remark || "";

//   return (
//     <div className="job-detail-page">
//       <main className="content">
//         {/* Header Layout */}
//         <section className="hero card">
//           <div className="hero-main">
//             <div className="store-icon">
//               <Store size={28} />
//             </div>

//             <div>
//               <h1>{title}</h1>

//               <div className="subline">
//                 Job ID: <b>{displayJobId}</b>
//               </div>

//               <div className="visit">
//                 <MapPin size={16} />
//                 Market / Dealer Visit
//               </div>
//             </div>
//           </div>

//           <div className="hero-meta">
//             {/* Applied At */}
//             <div className="hero-meta-item">
//               <CalendarDays />
//               <span>
//                 <b>{appliedTime}</b>
//                 <small>Applied At</small>
//               </span>
//             </div>

//             {/* Completed At */}
//             <div className="hero-meta-item">
//               <CalendarDays />
//               <span>
//                 <b>{completedAt}</b>
//                 <small>Completed At</small>
//               </span>
//             </div>
//           </div>
//         </section>

//         {/* Row 2 — 3 information cards */}
//         <section className="stats">
//           <Stat
//             icon={<Briefcase />}
//             value={company}
//             label="Company"
//             tone="purple"
//           />

//           <Stat
//             icon={<Tag />}
//             value={brand}
//             label="Brand"
//           />

//           <Stat
//             icon={<Layers />}
//             value={campaign}
//             label="Campaign"
//             tone="amber"
//           />
//         </section>

//         <section className="two-col">
//           <Card title="Basic Information">
//             <div className="basic-description">
//               <div className="basic-description-label">
//                 Job Description
//               </div>

//               <p className="description">
//                 {description}
//               </p>
//             </div>
//           </Card>

//           <Card title="Location & Media" icon={<MapPin />}>
//             <div className="map">
//               <div className="map-grid"></div>
//               <div className="river"></div>
//               <div className="map-label">{title}</div>
//               <div className="pin">
//                 <MapPin size={31} />
//               </div>
//               <button className="map-link" onClick={openInMaps}>
//                 <ExternalLink size={14} /> Open in Maps
//               </button>
//             </div>
//             <div className="location-line">
//               <div>
//                 <span>Coordinates</span>
//                 <b>{latitude ?? "N/A"}, {longitude ?? "N/A"}</b>
//               </div>
//               <span className="status-pill success">
//                 {latitude && longitude ? "Available" : "Missing"}
//               </span>
//             </div>
//             <div className="address">
//               <span>Address Note</span>
//               <b>{addressNote}</b>
//             </div>
//             <div
//               className="media-row"
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 overflowX: "auto",
//                 overflowY: "hidden",
//                 paddingBottom: "6px",
//                 scrollBehavior: "smooth",
//               }}
//             >
//               {previewPhotos.map((media, index) => {
//                 const mediaUrl = getInspectionMediaUrl(media);
//                 const isVideo = isInspectionVideo(media);

//                 const mediaKey = getDetailMediaKey(
//                   media,
//                   index,
//                   job
//                 );

//                 const discrepancyByUrl =
//                   mediaUrl
//                     ? mediaDiscrepancies[`url-${mediaUrl}`]
//                     : null;

//                 const discrepancyByKey =
//                   mediaDiscrepancies[mediaKey];

//                 const discrepancyByIndex =
//                   mediaDiscrepancies[`index-${index}`];

//                 const discrepancyData =
//                   discrepancyByUrl ||
//                   discrepancyByKey ||
//                   discrepancyByIndex;

//                 const hasDiscrepancy =
//                   discrepancyData?.discrepancy === true;

//                 console.log(
//                   "[JOB DETAIL FLAG MATCH]",
//                   {
//                     index,
//                     mediaUrl,
//                     mediaKey,
//                     discrepancyByUrl,
//                     discrepancyByKey,
//                     discrepancyByIndex,
//                     hasDiscrepancy,
//                   }
//                 );

//                 return (
//                   <MediaThumb
//                     key={`${mediaUrl}-${index}`}
//                     label={
//                       isVideo
//                         ? `Video ${index + 1}`
//                         : `Photo ${index + 1}`
//                     }
//                     url={mediaUrl}
//                     isVideo={isVideo}
//                     hasDiscrepancy={hasDiscrepancy}
//                     thumbnail={
//                       isVideo && media?.url?.thumbnail
//                         ? media.url.thumbnail
//                         : mediaUrl
//                     }
//                     onClick={() => openPhoto(index)}
//                   />
//                 );
//               })}

//               {previewPhotos.length === 0 && (
//                 <MediaThumb label="No Media" />
//               )}
//             </div>
//           </Card>
//         </section>

//         <Card title="Job Details" icon={<ClipboardList />}>
//           <div className="details-columns">
//             <div>
//               <Field label="Category" value={category} />
//               <Field label="Acceptance Type" value={acceptance} />
//               <Field label="Allow Gallery">
//                 <span className="status-pill danger">{gallery}</span>
//               </Field>
//               <Field label="Budget Note" value={budget} />
//               <Field label="Reference Description" value={reference} />
//               <Field label="Remark 1" value={remark1} />
//               <Field label="Remark 4" value={remark4} />
//             </div>
//             <div>
//               <Field label="Type" value={type} />
//               <Field label="Hours" value={hours} />
//               <Field label="Zoho Item ID" value={zoho} />
//               <Field label="Payment Gateway" value={gateway} />
//               <Field label="Price" value={price} />
//               <Field label="Base Currency" value={currency} />
//               <div className="mini-fields">
//                 <Field label="Remark 2" value={remark2} />
//                 <Field label="Remark 3" value={remark3} />
//                 <Field label="Number of Photos" value={photosCount} />
//               </div>
//             </div>
//           </div>
//         </Card>

//         {permissions.showOwner && (
//           <Card title="Owner Information" icon={<UserRound />}>
//             <div className="owner-grid">
//               <Owner label="Owner Name" value={ownerName} icon={<UserRound />} />
//               <Owner label="Owner Email" value={ownerEmail} icon={<Mail />} />
//               <Owner label="Owner Phone" value={ownerPhone} icon={<Phone />} />
//               <Owner label="Owner ID" value={ownerId} icon={<BadgeInfo />} />
//             </div>
//           </Card>
//         )}

//         {permissions.showSnapperApplications && (
//           <Card
//             title="Snapper's Applications"
//             icon={<UsersRound />}
//             action={
//               <button className="outline-btn">
//                 View All <ChevronRight size={14} />
//               </button>
//             }
//           >
//             <Table headers={["ID", "SNAPPER PHONE", "SNAPPER NAME", "APPLIED TIME", "STATUS", "ACTIONS"]}>
//               {applications.length > 0 ? (
//                 applications.map((app, i) => (
//                   <tr key={app.id || i}>
//                     <td>{app.id || displayJobId}</td>
//                     <td className="link">{app.snapper_phone || snapperPhone}</td>
//                     <td className="link">{app.snapper_name || snapper}</td>
//                     <td>{app.applied_time || appliedTime}</td>
//                     <td><span className="status-pill success">{app.status || status}</span></td>
//                     <td>
//                       <button className="small-btn"><Eye size={14} /> View</button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td>{displayJobId}</td>
//                   <td className="link">{snapperPhone}</td>
//                   <td className="link">{snapper}</td>
//                   <td>{appliedTime}</td>
//                   <td><span className="status-pill success">{status}</span></td>
//                   <td>
//                     <button className="small-btn"><Eye size={14} /> View</button>
//                   </td>
//                 </tr>
//               )}
//             </Table>
//           </Card>
//         )}

//         {permissions.showTransactions && (
//           <Card title="Transactions" icon={<IndianRupee />}>
//             <Table headers={["ID", "NAME", "ACTIONS"]}>
//               {transactions.length > 0 ? (
//                 transactions.map((tx, i) => (
//                   <tr key={tx.id || i}>
//                     <td>{tx.id || "N/A"}</td>
//                     <td>{tx.name || tx.description || JSON.stringify(tx)}</td>
//                     <td>
//                       <button className="small-btn"><Eye size={14} /> View</button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="3" style={{ textAlign: "center", color: "#6b7280" }}>
//                     No transaction history recorded.
//                   </td>
//                 </tr>
//               )}
//             </Table>
//           </Card>
//         )}

//         <div className="bottom-toolbar">
//           <div className="toolbar-actions">
//             <button className="btn secondary" onClick={openInMaps}>
//               <MapPin size={17} /> View on Map
//             </button>

//             <button
//               className="btn primary"
//               onClick={downloadReport}
//               disabled={isGeneratingReport}
//             >
//               <Download size={17} />
//               {isGeneratingReport ? "Generating..." : "Download Report"}
//             </button>
//           </div>
//         </div>
//       </main>

//       {selectedPhotoIndex !== null && (
//         <div className="photo-viewer-backdrop" onClick={closePhoto}>
//           <div className="photo-viewer" onClick={(e) => e.stopPropagation()}>
//             <button className="photo-viewer-close" onClick={closePhoto} aria-label="Close">
//               <X size={24} />
//             </button>

//             <button className="photo-viewer-arrow photo-viewer-prev" onClick={showPreviousPhoto} aria-label="Previous item">
//               ‹
//             </button>

//             {selectedIsVideo ? (
//               <video
//                 src={selectedMediaUrl}
//                 controls
//                 autoPlay
//                 className="photo-viewer-image"
//                 style={{ maxHeight: "70vh", maxWidth: "90vw" }}
//               />
//             ) : (
//               <img
//                 src={selectedMediaUrl}
//                 alt={`Media ${selectedPhotoIndex + 1}`}
//                 className="photo-viewer-image"
//                 style={{ maxHeight: "70vh", maxWidth: "90vw" }}
//               />
//             )}

//             <button className="photo-viewer-arrow photo-viewer-next" onClick={showNextPhoto} aria-label="Next item">
//               ›
//             </button>

//             <div className="photo-viewer-counter">
//               {selectedPhotoIndex + 1} / {allMedia.length}
//             </div>
//             {selectedHasDiscrepancy && (
//               <div
//                 className="discrepancy-remark-box"
//                 style={{
//                   marginTop: "12px",
//                   padding: "10px 12px",
//                   borderRadius: "6px",
//                   background: "#fff3f3",
//                   border: "1px solid #f0b0b0",
//                   width: "100%",
//                   maxWidth: "600px",
//                   boxSizing: "border-box",
//                 }}
//               >
//             {/* {selectedHasDiscrepancy && (
//               <div
//                 style={{
//                   marginTop: "12px",
//                   padding: "10px 12px",
//                   borderRadius: "6px",
//                   background: "#fff3f3",
//                   border: "1px solid #f0b0b0",
//                   width: "100%",
//                   maxWidth: "600px",
//                   boxSizing: "border-box",
//                 }}
//               > */}
//                 <div
//                   style={{
//                     fontWeight: 600,
//                     color: "#d32f2f",
//                     marginBottom: "4px",
//                   }}
//                 >
//                   🚩 Discrepancy Found
//                 </div>

//                 {selectedRemark && (
//                   <div style={{ color: "#333", fontSize: "14px" }}>
//                     <strong>Remark:</strong> {selectedRemark}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function Stat({ icon, value, label, tone = "" }) {
//   return (
//     <div className={`stat card ${tone}`}>
//       <div className="stat-icon">{icon}</div>
//       <div>
//         <strong>{value}</strong>
//         <span>{label}</span>
//       </div>
//     </div>
//   );
// }

// function Card({ title, icon, action, children }) {
//   return (
//     <section className="card section-card">
//       <div className="section-head">
//         <div className="section-title">
//           {icon && <span className="section-icon">{icon}</span>}
//           <h2>{title}</h2>
//         </div>
//         {action}
//       </div>
//       {children}
//     </section>
//   );
// }

// function Owner({ label, value, icon }) {
//   return (
//     <div className="owner">
//       <span className="owner-icon">{icon}</span>
//       <div>
//         <small>{label}</small>
//         <b>{value}</b>
//       </div>
//     </div>
//   );
// }

// function Table({ headers, children }) {
//   return (
//     <div className="table-wrap">
//       <table>
//         <thead>
//           <tr>
//             {headers.map((h) => (
//               <th key={h}>{h}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>{children}</tbody>
//       </table>
//     </div>
//   );
// }

// function MediaThumb({ label, large, url, isVideo, hasDiscrepancy, thumbnail, onClick }) {
//   return (
//     <div
//       className={`media-thumb ${large ? "large" : ""}`}
//       onClick={onClick}
//       role={onClick ? "button" : undefined}
//       tabIndex={onClick ? 0 : undefined}
//       onKeyDown={(e) => {
//         if (onClick && (e.key === "Enter" || e.key === " ")) {
//           onClick();
//         }
//       }}
//       style={{ position: "relative" }}
//     >
//       {hasDiscrepancy && (
//         <div
//           title="Discrepancy Flagged"
//           style={{
//             position: "absolute",
//             top: "6px",
//             right: "6px",
//             backgroundColor: "#ef4444",
//             color: "#ffffff",
//             borderRadius: "50%",
//             width: "22px",
//             height: "22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 10,
//             boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
//           }}
//         >
//           <AlertTriangle size={13} strokeWidth={2.5} />
//         </div>
//       )}

//       {url ? (
//         isVideo ? (
//           <div style={{ position: "relative", width: "100%", height: "100%" }}>
//             <img
//               src={thumbnail || url}
//               alt={label}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               loading="lazy"
//             />
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 background: "rgba(0,0,0,0.6)",
//                 borderRadius: "50%",
//                 padding: "6px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#fff",
//               }}
//             >
//               <Play size={16} fill="#fff" />
//             </div>
//           </div>
//         ) : (
//           <img
//             src={url}
//             alt={label}
//             style={{ width: "100%", height: "100%", objectFit: "cover" }}
//             loading="lazy"
//           />
//         )
//       ) : (
//         <div className="photo-placeholder">
//           <Store size={large ? 32 : 22} />
//         </div>
//       )}
//       <span>{label}</span>
//     </div>
//   );
// }

// export default JobDetailTest; 

import React, { useEffect, useState } from "react";
import {
  MapPin,
  Download,
  CalendarDays,
  UserRound,
  Phone,
  ClipboardList,
  Store,
  Mail,
  BadgeInfo,
  UsersRound,
  IndianRupee,
  Eye,
  ExternalLink,
  FileText,
  X,
  ChevronRight,
  Briefcase,
  Tag,
  Layers,
  Play,
  AlertTriangle,
} from "lucide-react";
import { useParams } from "react-router-dom";

import {
  getJobDetailTestData,
  getInspectionPhotoUrl,
  getInspectionMediaUrl,
  isInspectionVideo,
  generateJobReport,
  TEST_JOB_ID,
} from "../services/jobDetailTestService";

import { fetchJobMedia } from "../services/jobListService";
import { getJobMediaDiscrepancies } from "../services/mediaDiscrepancyService";
import "./job_detail_test.css";

const Field = ({ label, value, children }) => (
  <div className="field">
    <div className="field-label">{label}</div>
    <div className="field-value">{children ?? value}</div>
  </div>
);

// Helper function to enrich media object structure
const enrichDetailMedia = (media, index, job) => {
  if (!media) return {};

  if (typeof media === "string") {
    return {
      url: media,
      media_index: index,
      source_type: "job_message",
      source_id: job?.message_job_id ?? null,
      job_id: job?.id ?? null,
    };
  }

  return {
    ...media,

    job_id:
      media?.job_id ??
      media?.jobId ??
      job?.id ??
      job?.job_id ??
      null,

    media_index:
      media?.media_index ??
      media?.mediaIndex ??
      index,

    source_type:
      media?.source_type ??
      media?.sourceType ??
      "job_message",

    source_id:
      media?.source_id ??
      media?.sourceId ??
      media?.message_id ??
      media?.messageId ??
      media?.id ??
      job?.message_job_id ??
      job?.messageJobId ??
      null,
  };
};

const getDetailMediaUrl = (media) => {
  if (!media) return "";
  return getInspectionMediaUrl(media) || (typeof media === "string" ? media : media.url || media.photo_url || "");
};

// Unique key generator for media mapping
const getDetailMediaKey = (media, index, job) => {
  const enriched = enrichDetailMedia(media, index, job);

  const sourceType =
    enriched.source_type || "job_message";

  const sourceId =
    enriched.source_id || "unknown";

  const mediaIndex =
    enriched.media_index ?? index;

  const url =
    getDetailMediaUrl(enriched);

  return `${sourceType}-${sourceId}-${mediaIndex}-${url || ""}`;
};

function JobDetailTest() {
  const { jobId: routeJobId } = useParams();

  const [job, setJob] = useState(null);
  const [inspectionPhotos, setInspectionPhotos] = useState([]);
  const [inspectionVideos, setInspectionVideos] = useState([]);
  const [permissions, setPermissions] = useState({
    showOwner: false,
    showSnapperApplications: false,
    showTransactions: false,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  // Discrepancies state map
  const [mediaDiscrepancies, setMediaDiscrepancies] = useState({});

  useEffect(() => {
    let cancelled = false;

    const loadJob = async () => {
      try {
        setLoading(true);
        setError(null);

        const result = await getJobDetailTestData(routeJobId);

        if (cancelled) return;

        setJob(result?.job || {});
        setInspectionPhotos(result?.photos || []);
        setInspectionVideos(result?.videos || []);

        console.log("[JOB DETAIL PAGE] Images:", result?.photos || []);
        console.log("[JOB DETAIL PAGE] Videos:", result?.videos || []);

        setPermissions(
          result?.permissions || {
            showOwner: false,
            showSnapperApplications: false,
            showTransactions: false,
          }
        );
      } catch (err) {
        console.error("[JOB DETAIL TEST] Failed to load:", err);

        if (!cancelled) {
          setError(err?.message || "Failed to load job details.");
          setJob(null);
          setInspectionPhotos([]);
          setInspectionVideos([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadJob();

    return () => {
      cancelled = true;
    };
  }, [routeJobId]);

  const openPhoto = (index) => {
    setSelectedPhotoIndex(index);
  };

  const closePhoto = () => {
    setSelectedPhotoIndex(null);
  };

  const allMedia = [...inspectionPhotos, ...inspectionVideos];

  useEffect(() => {
    if (!job || allMedia.length === 0) {
      setMediaDiscrepancies({});
      return;
    }

    let cancelled = false;

    const loadJobDiscrepancies = async () => {
      try {
        const requestId = Number(routeJobId);

        console.log(
          "[JOB DETAIL] REQUEST ID FOR DISCREPANCY API:",
          requestId
        );

        if (!requestId) {
          console.error(
            "[JOB DETAIL] Missing request ID"
          );
          return;
        }

        const result =
          await getJobMediaDiscrepancies(requestId);

        console.log(
          "[JOB DETAIL] RAW DISCREPANCY RESULT:",
          result
        );

        if (cancelled) return;

        const discrepancies =
          Array.isArray(result)
            ? result
            : result?.discrepancies || [];

        console.log(
          "[JOB DETAIL] DISCREPANCIES:",
          discrepancies
        );

        const results = {};

        discrepancies.forEach((item) => {
          const sourceType =
            item?.source_type ??
            item?.sourceType ??
            "job_message";

          const sourceId =
            item?.source_id ??
            item?.sourceId ??
            null;

          const mediaIndex =
            item?.media_index ??
            item?.mediaIndex ??
            null;

          const mediaUrl = Array.isArray(item?.media_url)
            ? item.media_url[0]
            : (
                item?.media_url ??
                item?.mediaUrl ??
                ""
              );

          const discrepancy =
            item?.discrepancy === true ||
            item?.discrepancy === 1 ||
            item?.discrepancy === "1" ||
            item?.discrepancy === "true" ||
            item?.discrepancy === "TRUE";

          const remark =
            item?.discrepancy_reason ??
            item?.discrepancyReason ??
            item?.remark ??
            "";

          console.log(
            "[JOB DETAIL] DISCREPANCY RECORD:",
            {
              sourceType,
              sourceId,
              mediaIndex,
              mediaUrl,
              rawDiscrepancy: item?.discrepancy,
              discrepancy,
              jobId: item?.job_id,
            }
          );

          if (mediaUrl) {
            results[`url-${mediaUrl}`] = {
              discrepancy,
              remark,
              jobId: item?.job_id,
              sourceType,
              sourceId,
              mediaIndex,
              mediaUrl,
            };
          }

          if (
            sourceId !== null &&
            mediaIndex !== null
          ) {
            const mediaKey =
              `${sourceType}-${sourceId}-${mediaIndex}-${mediaUrl}`;

            results[mediaKey] = {
              discrepancy,
              remark,
              jobId: item?.job_id,
              sourceType,
              sourceId,
              mediaIndex,
              mediaUrl,
            };
          }

          if (mediaIndex !== null) {
            results[`index-${mediaIndex}`] = {
              discrepancy,
              remark,
              jobId: item?.job_id,
              sourceType,
              sourceId,
              mediaIndex,
              mediaUrl,
            };
          }
        });

        console.log(
          "[JOB DETAIL] FINAL DISCREPANCY MAP:",
          results
        );

        setMediaDiscrepancies(results);

      } catch (error) {
        console.error(
          "[JOB DETAIL] Discrepancy API error:",
          error
        );

        if (!cancelled) {
          setMediaDiscrepancies({});
        }
      }
    };

    loadJobDiscrepancies();

    return () => {
      cancelled = true;
    };
  }, [routeJobId, job, allMedia.length]);

  const showPreviousPhoto = () => {
    setSelectedPhotoIndex((current) => {
      if (current === null || allMedia.length === 0) {
        return current;
      }

      return (current - 1 + allMedia.length) % allMedia.length;
    });
  };

  const showNextPhoto = () => {
    setSelectedPhotoIndex((current) => {
      if (current === null || allMedia.length === 0) {
        return current;
      }

      return (current + 1) % allMedia.length;
    });
  };

  const downloadReport = async () => {
    if (!job?.id) {
      alert("Job ID is missing.");
      return;
    }

    try {
      setIsGeneratingReport(true);
      const result = await generateJobReport(job);

      if (result?.download_url) {
        const reportUrl = result.download_url.startsWith("http")
          ? result.download_url
          : `${process.env.REACT_APP_API_URL}${result.download_url}`;

        window.open(reportUrl, "_blank", "noopener,noreferrer");
      } else {
        alert("Report generated, but download link was not returned.");
      }
    } catch (error) {
      console.error("[JOB DETAIL] Report generation failed:", error);
      alert(error?.message || "Failed to generate report.");
    } finally {
      setIsGeneratingReport(false);
    }
  };

  if (loading) {
    return (
      <div className="job-detail-page">
        <main className="content">
          <div className="card section-card">
            <div className="field-value">Loading job details...</div>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="job-detail-page">
        <main className="content">
          <div className="card section-card">
            <div className="field-value">{error}</div>
          </div>
        </main>
      </div>
    );
  }

  if (!job) {
    return (
      <div className="job-detail-page">
        <main className="content">
          <div className="card section-card">
            <div className="field-value">No job data found.</div>
          </div>
        </main>
      </div>
    );
  }

  const formatDateTime = (value) => {
    if (!value) return "N/A";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const appliedTime = formatDateTime(
    job.applied_time ||
      job.appliedTime ||
      job.applied_at ||
      job.appliedAt ||
      job.created_at ||
      job.createdAt
  );

  const completedAt = formatDateTime(
    job.completed_at ||
      job.completedAt ||
      job.completed_at_time ||
      job.linked_completed_at ||
      job.linkedCompletedAt
  );

  const ownerPhone =
    job.owner_phone ||
    job.ownerPhone ||
    job.owner?.phone ||
    "N/A";

  const ownerObject = job.owner && typeof job.owner === "object" ? job.owner : null;
  const ownerName = job.owner_name || job.ownerName || ownerObject?.name || (typeof job.owner === "string" ? job.owner : "N/A");
  const ownerEmail = job.owner_email || job.ownerEmail || ownerObject?.email || "N/A";
  const ownerId = job.owner_id || job.ownerId || ownerObject?.id || "N/A";

  const snapperObject = job.snapper && typeof job.snapper === "object" ? job.snapper : null;
  const snapper = job.snapper_name || job.snapperName || snapperObject?.name || (typeof job.snapper === "string" ? job.snapper : "N/A");
  const snapperPhone = job.snapper_phone || job.snapperPhone || snapperObject?.phone || "N/A";

  const companyObject = job.company && typeof job.company === "object" ? job.company : null;
  const company = job.company_name || companyObject?.name || (typeof job.company === "string" ? job.company : "N/A");

  const brandObject = job.brand && typeof job.brand === "object" ? job.brand : null;
  const brand = job.brand_name || brandObject?.name || (typeof job.brand === "string" ? job.brand : "N/A");

  const campaignObject = job.campaign && typeof job.campaign === "object" ? job.campaign : null;
  const campaign = job.campaign_name || campaignObject?.name || (typeof job.campaign === "string" ? job.campaign : "N/A");

  const categoryObject = job.category && typeof job.category === "object" ? job.category : null;
  const category = job.category_name || job.categoryName || categoryObject?.name || (typeof job.category === "string" ? job.category : "N/A");

  const title = job.title || job.job_title || job.name || "N/A";
  const displayJobId = job.snap_job_id || job.snapJobId || job.job_id || job.jobId || job.id || routeJobId || TEST_JOB_ID;
  const status = job.status || job.job_status || "N/A";
  const description = job.job_description || job.description || job.jobDescription || "N/A";

  const locationData = job.location_data || job.locationData || job.location || {};
  const latitude = job.latitude ?? job.lat ?? locationData.latitude ?? locationData.lat;
  const longitude = job.longitude ?? job.lng ?? job.lon ?? locationData.longitude ?? locationData.lng;

  const type = job.type || job.job_type || "N/A";
  const price = job.price ?? job.budget ?? job.job_price ?? "N/A";
  const acceptance = job.acceptance_type || job.acceptanceType || "N/A";
  const hours = job.hours ?? job.duration ?? "N/A";

  const allowGallery = job.allow_gallery ?? job.allowGallery;
  const gallery = allowGallery === true ? "ENABLED" : allowGallery === false ? "DISABLED" : "N/A";

  const zoho = job.zoho_item_id || job.zohoItemId || "N/A";
  const gateway = job.payment_gateway || job.paymentGateway || "N/A";
  const currency = job.currency || job.base_currency || "INR";

  const addressNote = job.address_note || job.addressNote || job.location_note || "N/A";

  const budget = job.budget_note || job.budgetNote || "N/A";
  const reference = job.reference_description || job.referenceDescription || job.reference || "N/A";

  const referenceFiles = Array.isArray(job.reference_files)
    ? job.reference_files
    : [];

  const remark1 = job.remark1 || "N/A";
  const remark2 = job.remark2 || "N/A";
  const remark3 = job.remark3 || "N/A";
  const remark4 = job.remark4 || "N/A";

  const photosCount = allMedia.length || job.number_of_photos || job.numberOfPhotos || job.photos || 0;
  const applications = job.snapper_applications || job.snapperApplications || job.applications || [];
  const transactions = job.transactions || job.transaction_history || [];

  const openInMaps = () => {
    if (latitude === undefined || latitude === null || longitude === undefined || longitude === null) return;
    window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank", "noopener,noreferrer");
  };

  const openReferenceFile = (file) => {
    const url = file?.file_url;

    if (!url) {
      console.error("[JOB DETAIL] Reference file URL missing:", file);
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Show ALL inspection photos/videos
  const previewPhotos = allMedia;

  const selectedMedia =
    selectedPhotoIndex !== null
      ? allMedia[selectedPhotoIndex]
      : null;

  const selectedMediaUrl = selectedMedia ? getInspectionMediaUrl(selectedMedia) : null;
  const selectedIsVideo = selectedMedia ? isInspectionVideo(selectedMedia) : false;

  const selectedEnrichedMedia =
    selectedMedia && selectedPhotoIndex !== null
      ? enrichDetailMedia(selectedMedia, selectedPhotoIndex, job)
      : null;

  const selectedMediaKey =
    selectedEnrichedMedia && selectedPhotoIndex !== null
      ? getDetailMediaKey(
          selectedEnrichedMedia,
          selectedPhotoIndex,
          job
        )
      : null;

  const selectedUrlDiscrepancy =
    selectedMediaUrl
      ? mediaDiscrepancies[`url-${selectedMediaUrl}`]
      : null;

  const selectedKeyDiscrepancy =
    selectedMediaKey
      ? mediaDiscrepancies[selectedMediaKey]
      : null;

  const selectedDiscrepancyData =
    selectedUrlDiscrepancy ||
    selectedKeyDiscrepancy;

  const selectedHasDiscrepancy =
    selectedDiscrepancyData?.discrepancy === true;

  const selectedRemark =
    selectedDiscrepancyData?.remark || "";

  return (
    <div className="job-detail-page">
      <main className="content">
        {/* Header Layout */}
        <section className="hero card">
          <div className="hero-main">
            <div className="store-icon">
              <Store size={28} />
            </div>

            <div>
              <h1>{title}</h1>

              <div className="subline">
                Job ID: <b>{displayJobId}</b>
              </div>

              <div className="visit">
                <MapPin size={16} />
                Market / Dealer Visit
              </div>
            </div>
          </div>

          <div className="hero-meta">
            {/* Applied At */}
            <div className="hero-meta-item">
              <CalendarDays />
              <span>
                <b>{appliedTime}</b>
                <small>Applied At</small>
              </span>
            </div>

            {/* Completed At */}
            <div className="hero-meta-item">
              <CalendarDays />
              <span>
                <b>{completedAt}</b>
                <small>Completed At</small>
              </span>
            </div>
          </div>
        </section>

        {/* Row 2 — 3 information cards */}
        <section className="stats">
          <Stat
            icon={<Briefcase />}
            value={company}
            label="Company"
            tone="purple"
          />

          <Stat
            icon={<Tag />}
            value={brand}
            label="Brand"
          />

          <Stat
            icon={<Layers />}
            value={campaign}
            label="Campaign"
            tone="amber"
          />
        </section>

        <section className="two-col">
          <Card title="Basic Information">
            <div className="basic-description">
              <div className="basic-description-label">
                Job Description
              </div>

              <p className="description">
                {description}
              </p>
            </div>
          </Card>

          <Card
  title="Location & Media"
  icon={<MapPin />}
  action={
    referenceFiles.length > 0 && (
      <div className="reference-file-header">
        <span className="reference-file-title">
          Reference File
        </span>

        {referenceFiles.map((file, index) => (
          <button
            key={file.file_id || index}
            type="button"
            className="reference-file-button"
            onClick={() => openReferenceFile(file)}
            title={`Open ${file.file_name}`}
          >
            <FileText size={16} />

            <span className="reference-file-name">
              {file.file_name}
            </span>

            <ExternalLink size={15} />
          </button>
        ))}
      </div>
    )
  }
>
            <div className="map">
              <div className="map-grid"></div>
              <div className="river"></div>
              <div className="map-label">{title}</div>
              <div className="pin">
                <MapPin size={31} />
              </div>
              <button className="map-link" onClick={openInMaps}>
                <ExternalLink size={14} /> Open in Maps
              </button>
            </div>
            <div className="location-line">
              <div>
                <span>Coordinates</span>
                <b>{latitude ?? "N/A"}, {longitude ?? "N/A"}</b>
              </div>
              <span className="status-pill success">
                {latitude && longitude ? "Available" : "Missing"}
              </span>
            </div>
            <div className="address">
              <span>Address Note</span>
              <b>{addressNote}</b>
            </div>
            <div
              className="media-row"
              style={{
                display: "flex",
                gap: "10px",
                overflowX: "auto",
                overflowY: "hidden",
                paddingBottom: "6px",
                scrollBehavior: "smooth",
              }}
            >
              {previewPhotos.map((media, index) => {
                const mediaUrl = getInspectionMediaUrl(media);
                const isVideo = isInspectionVideo(media);

                const mediaKey = getDetailMediaKey(
                  media,
                  index,
                  job
                );

                const discrepancyByUrl =
                  mediaUrl
                    ? mediaDiscrepancies[`url-${mediaUrl}`]
                    : null;

                const discrepancyByKey =
                  mediaDiscrepancies[mediaKey];

                const discrepancyByIndex =
                  mediaDiscrepancies[`index-${index}`];

                const discrepancyData =
                  discrepancyByUrl ||
                  discrepancyByKey ||
                  discrepancyByIndex;

                const hasDiscrepancy =
                  discrepancyData?.discrepancy === true;

                console.log(
                  "[JOB DETAIL FLAG MATCH]",
                  {
                    index,
                    mediaUrl,
                    mediaKey,
                    discrepancyByUrl,
                    discrepancyByKey,
                    discrepancyByIndex,
                    hasDiscrepancy,
                  }
                );

                return (
                  <MediaThumb
                    key={`${mediaUrl}-${index}`}
                    label={
                      isVideo
                        ? `Video ${index + 1}`
                        : `Photo ${index + 1}`
                    }
                    url={mediaUrl}
                    isVideo={isVideo}
                    hasDiscrepancy={hasDiscrepancy}
                    thumbnail={
                      isVideo && media?.url?.thumbnail
                        ? media.url.thumbnail
                        : mediaUrl
                    }
                    onClick={() => openPhoto(index)}
                  />
                );
              })}

              {previewPhotos.length === 0 && (
                <MediaThumb label="No Media" />
              )}
            </div>
          </Card>
        </section>

        <Card title="Job Details" icon={<ClipboardList />}>
          <div className="details-columns">
            <div>
              <Field label="Category" value={category} />
              <Field label="Acceptance Type" value={acceptance} />
              <Field label="Allow Gallery">
                <span className="status-pill danger">{gallery}</span>
              </Field>
              <Field label="Budget Note" value={budget} />
              <Field label="Reference Description" value={reference} />
              <Field label="Remark 1" value={remark1} />
              <Field label="Remark 4" value={remark4} />
            </div>
            <div>
              <Field label="Type" value={type} />
              <Field label="Hours" value={hours} />
              <Field label="Zoho Item ID" value={zoho} />
              <Field label="Payment Gateway" value={gateway} />
              <Field label="Price" value={price} />
              <Field label="Base Currency" value={currency} />
              <div className="mini-fields">
                <Field label="Remark 2" value={remark2} />
                <Field label="Remark 3" value={remark3} />
                <Field label="Number of Photos" value={photosCount} />
              </div>
            </div>
          </div>
        </Card>

        {permissions.showOwner && (
          <Card title="Owner Information" icon={<UserRound />}>
            <div className="owner-grid">
              <Owner label="Owner Name" value={ownerName} icon={<UserRound />} />
              <Owner label="Owner Email" value={ownerEmail} icon={<Mail />} />
              <Owner label="Owner Phone" value={ownerPhone} icon={<Phone />} />
              <Owner label="Owner ID" value={ownerId} icon={<BadgeInfo />} />
            </div>
          </Card>
        )}

        {permissions.showSnapperApplications && (
          <Card
            title="Snapper's Applications"
            icon={<UsersRound />}
            action={
              <button className="outline-btn">
                View All <ChevronRight size={14} />
              </button>
            }
          >
            <Table headers={["ID", "SNAPPER PHONE", "SNAPPER NAME", "APPLIED TIME", "STATUS", "ACTIONS"]}>
              {applications.length > 0 ? (
                applications.map((app, i) => (
                  <tr key={app.id || i}>
                    <td>{app.id || displayJobId}</td>
                    <td className="link">{app.snapper_phone || snapperPhone}</td>
                    <td className="link">{app.snapper_name || snapper}</td>
                    <td>{app.applied_time || appliedTime}</td>
                    <td><span className="status-pill success">{app.status || status}</span></td>
                    <td>
                      <button className="small-btn"><Eye size={14} /> View</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>{displayJobId}</td>
                  <td className="link">{snapperPhone}</td>
                  <td className="link">{snapper}</td>
                  <td>{appliedTime}</td>
                  <td><span className="status-pill success">{status}</span></td>
                  <td>
                    <button className="small-btn"><Eye size={14} /> View</button>
                  </td>
                </tr>
              )}
            </Table>
          </Card>
        )}

        {permissions.showTransactions && (
          <Card title="Transactions" icon={<IndianRupee />}>
            <Table headers={["ID", "NAME", "ACTIONS"]}>
              {transactions.length > 0 ? (
                transactions.map((tx, i) => (
                  <tr key={tx.id || i}>
                    <td>{tx.id || "N/A"}</td>
                    <td>{tx.name || tx.description || JSON.stringify(tx)}</td>
                    <td>
                      <button className="small-btn"><Eye size={14} /> View</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", color: "#6b7280" }}>
                    No transaction history recorded.
                  </td>
                </tr>
              )}
            </Table>
          </Card>
        )}

        <div className="bottom-toolbar">
          <div className="toolbar-actions">
            <button className="btn secondary" onClick={openInMaps}>
              <MapPin size={17} /> View on Map
            </button>

            <button
              className="btn primary"
              onClick={downloadReport}
              disabled={isGeneratingReport}
            >
              <Download size={17} />
              {isGeneratingReport ? "Generating..." : "Download Report"}
            </button>
          </div>
        </div>
      </main>

      {selectedPhotoIndex !== null && (
        <div className="photo-viewer-backdrop" onClick={closePhoto}>
          <div className="photo-viewer" onClick={(e) => e.stopPropagation()}>
            <button className="photo-viewer-close" onClick={closePhoto} aria-label="Close">
              <X size={24} />
            </button>

            <button className="photo-viewer-arrow photo-viewer-prev" onClick={showPreviousPhoto} aria-label="Previous item">
              ‹
            </button>

            {selectedIsVideo ? (
              <video
                src={selectedMediaUrl}
                controls
                autoPlay
                className="photo-viewer-image"
                style={{ maxHeight: "70vh", maxWidth: "90vw" }}
              />
            ) : (
              <img
                src={selectedMediaUrl}
                alt={`Media ${selectedPhotoIndex + 1}`}
                className="photo-viewer-image"
                style={{ maxHeight: "70vh", maxWidth: "90vw" }}
              />
            )}

            <button className="photo-viewer-arrow photo-viewer-next" onClick={showNextPhoto} aria-label="Next item">
              ›
            </button>

            <div className="photo-viewer-counter">
              {selectedPhotoIndex + 1} / {allMedia.length}
            </div>
            {selectedHasDiscrepancy && (
              <div
                className="discrepancy-remark-box"
                style={{
                  marginTop: "12px",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  background: "#fff3f3",
                  border: "1px solid #f0b0b0",
                  width: "100%",
                  maxWidth: "600px",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: "#d32f2f",
                    marginBottom: "4px",
                  }}
                >
                  🚩 Discrepancy Found
                </div>

                {selectedRemark && (
                  <div style={{ color: "#333", fontSize: "14px" }}>
                    <strong>Remark:</strong> {selectedRemark}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Stat({ icon, value, label, tone = "" }) {
  return (
    <div className={`stat card ${tone}`}>
      <div className="stat-icon">{icon}</div>
      <div>
        <strong>{value}</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}

function Card({ title, icon, action, children }) {
  return (
    <section className="card section-card">
      <div className="section-head">
        <div className="section-title">
          {icon && <span className="section-icon">{icon}</span>}
          <h2>{title}</h2>
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}

function Owner({ label, value, icon }) {
  return (
    <div className="owner">
      <span className="owner-icon">{icon}</span>
      <div>
        <small>{label}</small>
        <b>{value}</b>
      </div>
    </div>
  );
}

function Table({ headers, children }) {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

function MediaThumb({ label, large, url, isVideo, hasDiscrepancy, thumbnail, onClick }) {
  return (
    <div
      className={`media-thumb ${large ? "large" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          onClick();
        }
      }}
      style={{ position: "relative" }}
    >
      {hasDiscrepancy && (
        <div
          title="Discrepancy Flagged"
          style={{
            position: "absolute",
            top: "6px",
            right: "6px",
            backgroundColor: "#ef4444",
            color: "#ffffff",
            borderRadius: "50%",
            width: "22px",
            height: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
          }}
        >
          <AlertTriangle size={13} strokeWidth={2.5} />
        </div>
      )}

      {url ? (
        isVideo ? (
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <img
              src={thumbnail || url}
              alt={label}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              loading="lazy"
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "rgba(0,0,0,0.6)",
                borderRadius: "50%",
                padding: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
              }}
            >
              <Play size={16} fill="#fff" />
            </div>
          </div>
        ) : (
          <img
            src={url}
            alt={label}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            loading="lazy"
          />
        )
      ) : (
        <div className="photo-placeholder">
          <Store size={large ? 32 : 22} />
        </div>
      )}
      <span>{label}</span>
    </div>
  );
}

export default JobDetailTest;